/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiScreeningFlowGoodlist
 */
export interface InternalApiScreeningFlowGoodlist {
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningFlowGoodlist
     */
    key1?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningFlowGoodlist
     */
    key2?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningFlowGoodlist
     */
    key3?: string;
}

/**
 * Check if a given object implements the InternalApiScreeningFlowGoodlist interface.
 */
export function instanceOfInternalApiScreeningFlowGoodlist(value: object): value is InternalApiScreeningFlowGoodlist {
    return true;
}

export function InternalApiScreeningFlowGoodlistFromJSON(json: any): InternalApiScreeningFlowGoodlist {
    return InternalApiScreeningFlowGoodlistFromJSONTyped(json, false);
}

export function InternalApiScreeningFlowGoodlistFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScreeningFlowGoodlist {
    if (json == null) {
        return json;
    }
    return {
        
        'key1': json['key1'] == null ? undefined : json['key1'],
        'key2': json['key2'] == null ? undefined : json['key2'],
        'key3': json['key3'] == null ? undefined : json['key3'],
    };
}

export function InternalApiScreeningFlowGoodlistToJSON(json: any): InternalApiScreeningFlowGoodlist {
    return InternalApiScreeningFlowGoodlistToJSONTyped(json, false);
}

export function InternalApiScreeningFlowGoodlistToJSONTyped(value?: InternalApiScreeningFlowGoodlist | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key1': value['key1'],
        'key2': value['key2'],
        'key3': value['key3'],
    };
}

